
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom"
import "./NewsAndMedia.scss"
import { UtilService } from 'services/shared/UtilService';
import { msgTypes } from 'constants/msgTypes';
import { PaginatorModel } from "model/utilModels/PaginatorModel";
import ApiUrl from "services/shared/ApiUrl";
import DOMPurify from 'dompurify';

const Newsletter = () => {
    const videoRef = useRef(null);
    const [recentNewsletter, setRecentNewsletter] = useState([]);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.playbackRate = 1; // 0.5x speed (half speed)
        }
    }, []);

    useEffect(() => {
        loadRecentNewsletter();
    }, [])

    //Prepare request body to get blog list
    const prepareRequest = () => {
        const requestBody = new PaginatorModel();
        requestBody.pageNumber = 0;
        requestBody.pageSize = 10;
        return requestBody;
    }

    //Get Blog list
    const loadRecentNewsletter = async () => {
        const requestBody = prepareRequest();
        const res = await UtilService.getNewsletterList(requestBody);
        if (res.statusMsg === msgTypes.SUCCESS.msg) {
            setRecentNewsletter(res?.data?.tbody || []);
        }
    }





    return (
        <>

            {/* <!--Page Header Start--> */}
            <section className="page-header newsletter-section">
                <video ref={videoRef} autoPlay muted loop playsInline>
                    <source src="https://www.oneworldnetwork.co/video/1wn-newsletter.mp4" type="video/mp4" />
                </video>
                <div className="page-header__bg news-media-banner">
                </div>
                <div className="container">
                    <div className="page-header__inner">
                        {/* <h2>News And Media</h2> */}
                        <div className="thm-breadcrumb__box">
                            <ul className="thm-breadcrumb list-unstyled">

                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!--Page Header End--> */}

            {/* <!--News One Start--> */}
            <section class="blog-one">
                <div class="container">
                    <div class="section-title text-center">
                        <div class="section-title__tagline-box">
                            <span class="section-title__tagline">Latest News</span>
                        </div>
                        {/* <h2 class="section-title__title">Streamlining your supply<br /> chain processes</h2> */}
                    </div>
                    <div class="row">
                        {/* <!--News One Single Start--> */}
                        {recentNewsletter.map((newsletter, index) => (
                            <div class="col-xl-4 col-lg-4 blog-one__single-sec wow fadeInLeft" key={index} data-wow-delay="100ms">
                                <div class="blog-one__single">
                                    <div class="blog-one__img-box">
                                        <a href={newsletter.image ? ApiUrl.fileBaseUrl + newsletter.image : "/images/events/no_images.png"} target="_blank">
                                            <div className="blog-one__img">
                                                <img
                                                    src={newsletter.image ? ApiUrl.fileBaseUrl + newsletter.image : "/images/events/no_images.png"}
                                                    alt={newsletter.altTag || "Blog image"}
                                                />
                                            </div>
                                        </a>

                                        {/* <div class="blog-one__date">
                                            <p>July</p>
                                        </div> */}
                                    </div>
                                    <div class="blog-one__content">
                                        <h3 class="blog-one__title"><a href="/images/pdf/event/july.pdf" target="_blank">{newsletter.title}</a></h3>
                                        <p class="blog-one__text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(newsletter.description || "") }}></p>
                                      <div className="blog-one__read-more">
    <a
        href={newsletter.link?.trim() || undefined}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(event) => {
            if (!newsletter.link?.trim()) {
                event.preventDefault();
            }
        }}
    >
        Read More<span className="icon-arrow-right"></span>
    </a>
</div>

                                    </div>
                                </div>
                            </div>
                        ))}
                        {/* <!--News One Single End--> */}
                    </div>
                </div>
            </section>
            {/* <!--News One End--> */}

        </>
    )
}
export default Newsletter